import {File, FileApi, FILES_API_PATH} from "@betrue/shared/interfaces";
import {useState} from "react";
import {gql, useMutation} from "@apollo/client";
import {useResult} from "./results";
import {BASE_ENTITY_FIELDS} from "./base-fields";

export const CORE_FILE_FIELDS = gql`

  fragment CoreFileField on FileModel{
    ${BASE_ENTITY_FIELDS}
    encoding
    filename
    mimetype
    size
  }
`;

const UPLOAD_INVOICE = gql`
  ${CORE_FILE_FIELDS}

  mutation invoiceUpload($file: Upload!) {
    uploadInvoiceFile(file: $file) {
      ...CoreFileField
    }
  }
`;

const DELETE_FILE = gql`
  ${CORE_FILE_FIELDS}
  mutation deleteFile($id: String!) {
    deleteFile(id: $id){
      ...CoreFileField
    }
  }
`;


export const useFile = <T = File | File[]>(initial?: T): [T, FileApi] => {
  const [result, setResult] = useState<T>(initial);
  const uploadInvoice = useResult(useMutation(UPLOAD_INVOICE), setResult)
  const deleteFile = useResult(useMutation(DELETE_FILE,{}), setResult)

  return [
    result,
    {
      deleteFile(id: string) {
        deleteFile({
          variables: {
            id: id
          }
        })
      },
      uploadInvoiceFile(file: any) {
        uploadInvoice({
          variables: {
            file: file
          }
        })
      }
    }]
}
